export function getRatingImageForNumber(number, tripadvisorIcon = true) {
  return tripadvisorIcon
    ? `https://www.tripadvisor.com/img/cdsi/img2/ratings/traveler/${number.toFixed(1)}-20402-5.svg`
    : `https://www.tripadvisor.com/img/cdsi/img2/ratings/traveler/s${number.toFixed(1)}-MCID-5.svg`
}
